export const getConfig = () => ({
  publicRuntimeConfig: {
    assetPrefix: '/ustorethemes/ACSReprintsv1c',
    apiUrl: '/uStoreRestAPI',
    classicUrl: '/ustore',
    themeCustomizationUrl: '/uStoreThemeCustomizations',
    serverDomain: 'http://localhost:5000'
  }
})
